<h1 mat-dialog-title>
    <i class="dialog-icon text-danger fas fa-exclamation-circle mr1"></i>
    Error
</h1>
<mat-dialog-content [innerHTML]="data">
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
